<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
<!-- <sm-title-bar pageTitle="All today's bookings"></sm-title-bar> -->
<sm-title-bar pageTitle="All unpaid bills/invoices" [backWithParams]="true"></sm-title-bar>

</div>
</div>
<div class="col-sm-3">
  <!-- <div class="search_bar_custom">
    <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput placeholder="Search for services">
        <button mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
        </button>
    </mat-form-field>
</div> -->
</div>
</div>

<mat-card *ngIf="!loader && unpaidInvoicesData.length > 0">
    <div class="rounded-3 bg-light">
      <sm-data-table-for-appointments [columnHeaders]="tableDisplayColumns" 
                      
                     [dataSource]="unpaidInvoicesData" 
                     [showMenuButton]="true"
                     [menuDropdownTemplate]="menuTemplate" 
                     [showPagination]="true" 
                     [itemsPerPage]="25"
                     [rowClickHandler]="rowClickHandler"

                     >
                  
                    
      </sm-data-table-for-appointments>

 
      
    </div>
  </mat-card>
  
  <ng-template #menuTemplate let-rowvalue>
    <!-- OPTION MENUS FOR BOOKINGS -->
     <div *ngIf="rowvalue.data_type == 1">
      <button mat-menu-item  (click)="openInvoice(rowvalue)">
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
      </button>
      <!-- <button mat-menu-item *ngIf="((rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2) && (rowvalue.customer_hash && rowvalue.customer_hash != 'null'))" (click)="confirmBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2 || rowvalue.appointment_status == 7 || rowvalue.appointment_status == 9 || rowvalue.appointment_status == 5)" (click)="startProcess(rowvalue)">
      <mat-icon class="material-icons-outlined">timer</mat-icon>
      <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2 || rowvalue.appointment_status == 7 || rowvalue.appointment_status == 9 || rowvalue.appointment_status == 5)  && rowvalue.is_owner == 1  " (click)="assignJob(rowvalue)">
      <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
      <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
    </button>
    
    <button mat-menu-item *ngIf="(rowvalue.appointment_status == 3 || rowvalue.appointment_status == 5)" (click)="done(rowvalue)">
      <mat-icon class="material-icons-outlined">task_alt</mat-icon>
      <span>{{ 'business_bookings.opt_done' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.appointment_status == 3 || rowvalue.appointment_status == 9 || rowvalue.appointment_status == 4) && rowvalue.is_owner == 1" (click)="customiseBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">tune</mat-icon>
      <span>Edit data</span>
    </button>
   
    <button mat-menu-item *ngIf="(rowvalue.appointment_status == 3 || rowvalue.appointment_status == 9 || rowvalue.appointment_status == 4 || rowvalue.appointment_status == 7)  && rowvalue.is_owner == 1 " (click)="reset(rowvalue)">
      <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
      <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.appointment_status == 4 " (click)="openInvoice(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="((rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2 || rowvalue.appointment_status == 5) && rowvalue.is_owner == 1 )" (click)="cancelBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(!rowvalue.customer_hash || rowvalue.customer_hash == 'null') && rowvalue.is_owner == 1 " (click)="deleteBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete booking</span>
    </button> -->


     </div>

  <!-- OPTION MENUS FOR QUERIES -->


  <div *ngIf="rowvalue.data_type == 2">
        
       <button mat-menu-item (click)="bookingDetails(rowvalue)">
       <mat-icon class="material-icons-outlined">info</mat-icon>
       <span>View details</span>
       </button>
     
      

  </div>
 
  </ng-template>
  

  
  <ng-template #image let-objValue>
    <img
    onerror="this.src='../../../../../assets/images/user-avatar.svg'"
      [src]="
        objValue['customer_thumb_image'] !== null && objValue['customer_thumb_image'] !== 'null' && objValue['customer_thumb_image'] !== ''
          ? objValue['customer_thumb_image']
          : '../../../../../assets/images/user-avatar.svg'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>